import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, toDisplayString as _toDisplayString, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "section" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", { class: "title" }, "Create a new profile", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = { class: "columns is-1-mobile is-1-tablet is-3-desktop is-8-widescreen is-2-fullhd" }
const _hoisted_6 = { class: "column" }
const _hoisted_7 = {
  key: 0,
  class: "has-text-centered"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("br")
], -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("br")
], -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", { class: "is-size-4" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "icon has-text-success" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check-circle" })
  ]),
  /*#__PURE__*/_createTextVNode(" A verification link has been sent to your email account ")
], -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("hr", {
  class: "is-centered has-text-centered",
  style: {"width":"71%","margin":"20px auto"}
}, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", null, " Please, click on the link that has just been sent to your email account to verify your email and continue the registration process. ", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("br")
], -1)
const _hoisted_14 = [
  _hoisted_8,
  _hoisted_9,
  _hoisted_10,
  _hoisted_11,
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = { class: "columns is-1-mobile is-1-tablet is-3-desktop is-8-widescreen is-2-fullhd" }
const _hoisted_16 = { class: "column" }
const _hoisted_17 = { class: "field" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", { class: "label" }, [
  /*#__PURE__*/_createTextVNode("First name "),
  /*#__PURE__*/_createElementVNode("span", { class: "has-text-danger" }, "*")
], -1)
const _hoisted_19 = { class: "control" }
const _hoisted_20 = ["disabled"]
const _hoisted_21 = { class: "help is-danger" }
const _hoisted_22 = { class: "field" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", { class: "label" }, [
  /*#__PURE__*/_createTextVNode("Last name "),
  /*#__PURE__*/_createElementVNode("span", { class: "has-text-danger" }, "*")
], -1)
const _hoisted_24 = { class: "control" }
const _hoisted_25 = ["disabled"]
const _hoisted_26 = { class: "help is-danger" }
const _hoisted_27 = { class: "field" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("label", { class: "label" }, [
  /*#__PURE__*/_createTextVNode("Email "),
  /*#__PURE__*/_createElementVNode("span", { class: "has-text-danger" }, "*")
], -1)
const _hoisted_29 = { class: "control" }
const _hoisted_30 = ["disabled"]
const _hoisted_31 = { class: "help is-danger" }
const _hoisted_32 = { class: "field" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("label", { class: "label" }, [
  /*#__PURE__*/_createTextVNode("Password "),
  /*#__PURE__*/_createElementVNode("span", { class: "has-text-danger" }, "*")
], -1)
const _hoisted_34 = { class: "control" }
const _hoisted_35 = ["disabled"]
const _hoisted_36 = { class: "help is-danger" }
const _hoisted_37 = { class: "field" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("label", {
  for: "",
  class: "label"
}, [
  /*#__PURE__*/_createTextVNode("Verify password "),
  /*#__PURE__*/_createElementVNode("span", { class: "has-text-danger" }, "*")
], -1)
const _hoisted_39 = { class: "control" }
const _hoisted_40 = ["disabled"]
const _hoisted_41 = { class: "help is-danger" }
const _hoisted_42 = { class: "column" }
const _hoisted_43 = { class: "field" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("label", {
  for: "",
  class: "label"
}, [
  /*#__PURE__*/_createTextVNode("Organization name "),
  /*#__PURE__*/_createElementVNode("span", { class: "has-text-danger" }, "*")
], -1)
const _hoisted_45 = { class: "control" }
const _hoisted_46 = ["disabled"]
const _hoisted_47 = { class: "help is-danger" }
const _hoisted_48 = { class: "field" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("label", {
  for: "",
  class: "label"
}, [
  /*#__PURE__*/_createTextVNode("Role "),
  /*#__PURE__*/_createElementVNode("span", { class: "has-text-danger" }, "*")
], -1)
const _hoisted_50 = { class: "control" }
const _hoisted_51 = ["disabled"]
const _hoisted_52 = { class: "help is-danger" }
const _hoisted_53 = { class: "field" }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("label", {
  for: "",
  class: "label"
}, "Notes / comments", -1)
const _hoisted_55 = { class: "control" }
const _hoisted_56 = ["disabled"]
const _hoisted_57 = {
  key: 0,
  class: "message is-danger"
}
const _hoisted_58 = { class: "message-body" }
const _hoisted_59 = { class: "field" }
const _hoisted_60 = {
  for: "",
  class: "checkbox"
}
const _hoisted_61 = /*#__PURE__*/_createTextVNode(" I agree with the ")
const _hoisted_62 = /*#__PURE__*/_createElementVNode("a", {
  href: "/privacy.html",
  target: "_blank"
}, "privacy statement", -1)
const _hoisted_63 = /*#__PURE__*/_createTextVNode(" and ")
const _hoisted_64 = /*#__PURE__*/_createElementVNode("a", {
  href: "/terms.html",
  target: "_blank"
}, "terms of service", -1)
const _hoisted_65 = /*#__PURE__*/_createTextVNode(". ")
const _hoisted_66 = { class: "help is-danger" }
const _hoisted_67 = /*#__PURE__*/_createElementVNode("div", { class: "field" }, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "button is-success",
    type: "submit"
  }, "Register")
], -1)
const _hoisted_68 = /*#__PURE__*/_createElementVNode("div", { class: "field" }, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode("Or you "),
    /*#__PURE__*/_createElementVNode("a", { href: "/login.html" }, "already registered"),
    /*#__PURE__*/_createTextVNode("?")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          (_ctx.sent)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_14))
            : _createCommentVNode("", true)
        ])
      ]),
      (!_ctx.sent)
        ? (_openBlock(), _createElementBlock("form", {
            key: 0,
            onSubmit: _cache[9] || (_cache[9] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.register && _ctx.register(...args)), ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _hoisted_18,
                  _createElementVNode("div", _hoisted_19, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.data.fName) = $event)),
                      type: "text",
                      disabled: _ctx.disabled,
                      class: _normalizeClass(["input", { 'is-danger': _ctx.errors.fName }])
                    }, null, 10, _hoisted_20), [
                      [_vModelText, _ctx.data.fName]
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_21, _toDisplayString(_ctx.errors.fName), 1)
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _hoisted_23,
                  _createElementVNode("div", _hoisted_24, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.data.lName) = $event)),
                      type: "text",
                      class: _normalizeClass(["input", { 'is-danger': _ctx.errors.lName }]),
                      disabled: _ctx.disabled
                    }, null, 10, _hoisted_25), [
                      [_vModelText, _ctx.data.lName]
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_26, _toDisplayString(_ctx.errors.lName), 1)
                ]),
                _createElementVNode("div", _hoisted_27, [
                  _hoisted_28,
                  _createElementVNode("div", _hoisted_29, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.data.email) = $event)),
                      type: "text",
                      class: _normalizeClass(["input", { 'is-danger': _ctx.errors.email }]),
                      disabled: _ctx.disabled
                    }, null, 10, _hoisted_30), [
                      [_vModelText, _ctx.data.email]
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_31, _toDisplayString(_ctx.errors.email), 1)
                ]),
                _createElementVNode("div", _hoisted_32, [
                  _hoisted_33,
                  _createElementVNode("div", _hoisted_34, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.data.pass) = $event)),
                      type: "password",
                      class: _normalizeClass(["input", { 'is-danger': _ctx.errors.pass }]),
                      disabled: _ctx.disabled
                    }, null, 10, _hoisted_35), [
                      [_vModelText, _ctx.data.pass]
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_36, _toDisplayString(_ctx.errors.pass), 1)
                ]),
                _createElementVNode("div", _hoisted_37, [
                  _hoisted_38,
                  _createElementVNode("div", _hoisted_39, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.pass1) = $event)),
                      type: "password",
                      class: _normalizeClass(["input", { 'is-danger': _ctx.errors.pass1 }]),
                      disabled: _ctx.disabled
                    }, null, 10, _hoisted_40), [
                      [_vModelText, _ctx.pass1]
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_41, _toDisplayString(_ctx.errors.pass1), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_42, [
                _createElementVNode("div", _hoisted_43, [
                  _hoisted_44,
                  _createElementVNode("div", _hoisted_45, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.data.organization) = $event)),
                      type: "text",
                      class: _normalizeClass(["input", { 'is-danger': _ctx.errors.organization }]),
                      disabled: _ctx.disabled
                    }, null, 10, _hoisted_46), [
                      [_vModelText, _ctx.data.organization]
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_47, _toDisplayString(_ctx.errors.organization), 1)
                ]),
                _createElementVNode("div", _hoisted_48, [
                  _hoisted_49,
                  _createElementVNode("div", _hoisted_50, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.data.role) = $event)),
                      type: "text",
                      class: _normalizeClass(["input", { 'is-danger': _ctx.errors.role }]),
                      disabled: _ctx.disabled
                    }, null, 10, _hoisted_51), [
                      [_vModelText, _ctx.data.role]
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_52, _toDisplayString(_ctx.errors.role), 1)
                ]),
                _createElementVNode("div", _hoisted_53, [
                  _hoisted_54,
                  _createElementVNode("div", _hoisted_55, [
                    _withDirectives(_createElementVNode("textarea", {
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.data.note) = $event)),
                      type: "text",
                      class: "textarea",
                      disabled: _ctx.disabled
                    }, null, 8, _hoisted_56), [
                      [_vModelText, _ctx.data.note]
                    ])
                  ])
                ])
              ])
            ]),
            (_ctx.error)
              ? (_openBlock(), _createElementBlock("article", _hoisted_57, [
                  _createElementVNode("div", _hoisted_58, _toDisplayString(_ctx.error), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_59, [
              _createElementVNode("label", _hoisted_60, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.agree) = $event))
                }, null, 512), [
                  [_vModelCheckbox, _ctx.agree]
                ]),
                _hoisted_61,
                _hoisted_62,
                _hoisted_63,
                _hoisted_64,
                _hoisted_65
              ]),
              _createElementVNode("p", _hoisted_66, _toDisplayString(_ctx.errors.agree), 1)
            ]),
            _hoisted_67,
            _hoisted_68
          ], 32))
        : _createCommentVNode("", true)
    ])
  ]))
}